import React, { useEffect, useParams } from 'react';
import InfoSection from '../InfoSection'
import { unsubscribeSectionContent, unsubscribeFailSectionContent } from './content';
import { decryptData, decryptFormatted, encryptAndFormat, encryptData, generateKey } from '../../utils/crypto';

const Unsubscribe = () => {

  //const { hash } = useParams();

  //console.log(hash);

  useEffect(async () => {
    // const encryptedData = await encryptData(`test@test.com:John Doe`);
    // console.log("encryptedData",  encryptedData);
    // const decryptedData = await decryptData();
    // console.log("decryptedData",  decryptedData);

    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const encryptedData = await encryptAndFormat("test@test.com:John Doe", secretKey);
    console.log("encryptedData",  encryptedData);
    const decryptedData = await decryptFormatted(encryptedData, secretKey);
    console.log("decryptedData",  decryptedData);
  }, []);

  return (
    <>
      <InfoSection { ...unsubscribeSectionContent } />
      <InfoSection { ...unsubscribeFailSectionContent } />
    </>
  );
};

export default Unsubscribe;
